module.exports = __webpack_public_path__ + "build/img/banner3.5438feb5.jpg";